const LINES = ['Make the work', 'behind your business', 'work better.'];
const STEP = 0.045; // seconds per character
const START = 0.5; // wait for rules to start drawing

/** Typewriter reveal: every character is laid out from the start (no layout shift), only opacity animates. */
export default function TypedTitle() {
  let index = 0;
  const total = LINES.join('').length;
  return (
    <h1
      aria-label={LINES.join(' ')}
      className="mt-8 text-[40px] font-light leading-[1.06] tracking-[-0.02em] text-primary-500 sm:text-5xl lg:text-[68px]"
    >
      {LINES.map((line, li) => (
        <span key={line} aria-hidden="true">
          <span className="sm:block sm:whitespace-nowrap">
            {line.split('').map((ch, ci) => {
              const delay = START + index * STEP;
              index += 1;
              return (
                <span key={`${li}-${ci}`} className="type-char" style={{ animationDelay: `${delay}s` }}>
                  {ch}
                </span>
              );
            })}
            {li === LINES.length - 1 && (
              <span
                className="type-caret"
                style={{ animationDelay: `${START}s, ${START + total * STEP + 1.6}s` }}
              />
            )}
          </span>
          {li < LINES.length - 1 ? ' ' : null}
        </span>
      ))}
    </h1>
  );
}